import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useCheckout } from '../../useCheckout';
import BasketDeliverableDialog from '@/b2b/basket/ui/BasketDeliverableDialog.vue';
import { computed } from 'vue';
import CheckoutPaymentItemsOutOfStock from '@/b2b/checkout/ui/payment/CheckoutPaymentItemsOutOfStock.vue';
import CheckoutPaymentDeliveryDateChanged from '@/b2b/checkout/ui/payment/CheckoutPaymentDeliveryDateChanged.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import dictionaryService from '@/core/dictionary/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentReady',
  setup(__props) {

const labels = useBlockLabels();
const { itemIdsOutOfStock, clearItemIdsOutOfStock, hasDeliveryDateChanged } = useCheckout();

const hasItemsOutOfStock = computed<boolean>(() => itemIdsOutOfStock.value.length > 0);
const hasDeliveryDateChangedComputed = computed<boolean>(() => {
    return hasDeliveryDateChanged.value;
});

const close = (): void => {
    clearItemIdsOutOfStock();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BasketDeliverableDialog, {
      "is-open": _unref(hasItemsOutOfStock),
      heading: _unref(dictionaryService).pluralize(_unref(itemIdsOutOfStock).length, _unref(labels).paymentItemsOutOfStockHeader, _unref(labels).paymentItemsOutOfStockHeaderPlural),
      class: "lg:max-w-500",
      onClose: close
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, {
          name: "o-anim-fade-300",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckoutPaymentItemsOutOfStock)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "heading"]),
    _createVNode(BasketDeliverableDialog, {
      "is-open": _unref(hasDeliveryDateChangedComputed),
      heading: _unref(labels).earliestDeliveryDateChangedHeader,
      class: "lg:max-w-500"
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, {
          name: "o-anim-fade-300",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckoutPaymentDeliveryDateChanged)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "heading"])
  ], 64))
}
}

})